import Vue from 'vue'
import Vuex from 'vuex'
import { Motivos_de_traslado  } from '@/FirebaseConfig'
import {cleanObject,secondsToFullTimestamp} from '@/Helper.js' 
Vue.use(Vuex)
export default {
    namespaced:true,
    state: {
      data:{
        nombre:'',
        creado_el:'',
        código: ''
      },
      record:{},
      selectedKey:'',
      dialog: false,
    },
    mutations: {
      
      getAllItems(state, item) {
        Vue.set( state.record, item.id,  {...item.data(), creado_el: secondsToFullTimestamp(item.data().creado_el)} )
      },
      clean(state,key){
        Vue.delete(state.record, key)
      },
    },
    actions: {
     
      getAll:context=>{
        context.state.record = {}
        Motivos_de_traslado.onSnapshot(data=>data.docs.map( item => context.commit( 'getAllItems', item  ) ) )
      },
      add: context => {
        if(context.state.selectedKey==''){
        Motivos_de_traslado.add({nombre: context.state.data.nombre.toUpperCase(), código: context.state.data.código.padStart(2, 0), creado_el: new Date}).then(()=>{
          context.commit('Helpers/launchSnackbar', 'Se ha registrado un motivo de traslado correctamente', { root: true })
          cleanObject(context.state.data)
          context.state.dialog = false
        })}else{
          Motivos_de_traslado.doc(context.state.selectedKey).update({nombre: context.state.data.nombre.toUpperCase(), código: context.state.data.código.padStart(2, 0) }).then(()=>{
            context.commit('Helpers/launchSnackbar', ' Ha sido modificado correctamente', { root: true })                  
            cleanObject(context.state.data)
            context.state.dialog = false
          })
        }
      },
      clean:(context, key)=>{
        Motivos_de_traslado.doc(key).delete().then(()=>{
            context.commit('Helpers/launchSnackbar', 'Se ha eliminado con éxito', { root: true })                
            context.commit('clean',key)})
      },
      get:(context,key)=>{
        Motivos_de_traslado.doc(key).get().then(doc=>{
          context.state.data=doc.data()
          context.state.selectedKey=doc.id
          context.state.dialog = true
        })
      },
      clearForm:(context)=>{
        context.state.dialog = false
        context.state.selectedKey = ''
        context.state.data = {
          nombre: '',
          código: ''
        }
      },
    },
    getters:{
      record: state =>Object.keys(state.record).map(item =>({...state.record[item], key:item}))
    }    
}